import axios from 'axios'
import { API_BASE_URL } from './client'
import type { TokenPair } from '@/types'

export const authApi = {
  register: async (email: string, password: string, name: string, linkCode?: string): Promise<TokenPair> => {
    const { data } = await axios.post<TokenPair>(`${API_BASE_URL}/auth/register`, {
      email, password, name, link_code: linkCode || undefined,
    })
    return data
  },

  login: async (email: string, password: string): Promise<TokenPair> => {
    const { data } = await axios.post<TokenPair>(`${API_BASE_URL}/auth/login`, { email, password })
    return data
  },

  logout: async (refreshToken: string): Promise<void> => {
    await axios.post(`${API_BASE_URL}/auth/logout`, { refresh_token: refreshToken }).catch(() => {})
  },
}
